<td>
  <div class="runner">
    <div class="name">
      <span> {{ data?.runnerName }}</span>
    </div>
    <div class="pnl">
      @let runnerNetEffect = runnerNetEffect$ | async;
      @let runnerPNetEffect = runnerPNetEffect$ | async;
      @if (!isNil(runnerNetEffect)) {
        <b
          [ngClass]="{
            'pnl-green': runnerNetEffect >= 0,
            'pnl-red': runnerNetEffect < 0,
          }"
          >{{ runnerNetEffect | number: "1.2-2" }}</b
        >
      }
      @if (!isNil(runnerPNetEffect)) {
        <b
          [ngClass]="{
            'pnl-green': runnerPNetEffect >= 0,
            'pnl-red': runnerPNetEffect < 0,
          }"
          >&nbsp;&#xbb;&nbsp;{{ runnerPNetEffect | number: "1.2-2" }}</b
        >
      }
    </div>
  </div>
</td>
@let exchangeRate = exRateService.exRate$ | async;
@let exRate = exchangeRate?.RATE ?? 1;
<td class="odd-cell">
  @if (isAutoBm) {
    <a class="value-cell dummy-cell" [ngClass]="{ changed: row?.back3?.changed && priceChangeFlash }">
      <span class="value-price">
        {{ row?.back3?.price || "-" }}
      </span>
      <span class="value-size">
        {{ row?.back3?.size ? (row?.back3?.size * exRate | number: "1.0-0") : "-" }}
      </span>
    </a>
  }
</td>
<td class="odd-cell">
  @if (isAutoBm) {
    <a class="value-cell dummy-cell" [ngClass]="{ changed: row?.back2?.changed && priceChangeFlash }">
      <span class="value-price">
        {{ row?.back2?.price || "-" }}
      </span>
      <span class="value-size">
        {{ row?.back2?.size ? (row?.back2?.size * exRate | number: "1.0-0") : "-" }}
      </span>
    </a>
  }
</td>
@if (isRowActive) {
  <td class="odd-cell">
    <a
      (click)="
        handleSelect({
          PRICE: row?.back1?.price,
          SIZE: row?.back1?.size,
          SIDE: 'BACK',
        })
      "
      class="value-cell bg-back"
      [ngClass]="{ changed: row?.back1?.changed && priceChangeFlash }">
      <span class="value-price">
        {{ row?.back1?.price || "-" }}
      </span>
      @if (isAutoBm) {
        <span class="value-size">
          {{ row?.back1?.size ? (row?.back1?.size * exRate | number: "1.0-0") : "-" }}
        </span>
      }
    </a>
  </td>
  <td class="odd-cell">
    <a
      (click)="
        handleSelect({
          PRICE: row?.lay1?.price,
          SIZE: row?.lay1?.size,
          SIDE: 'LAY',
        })
      "
      class="value-cell bg-lay"
      [ngClass]="{ changed: row?.lay1?.changed && priceChangeFlash }">
      <span class="value-price">
        {{ row?.lay1?.price || "-" }}
      </span>
      @if (isAutoBm) {
        <span class="value-size">
          {{ row?.lay1?.size ? (row?.lay1?.size * exRate | number: "1.0-0") : "-" }}
        </span>
      }
    </a>
  </td>
} @else {
  <td style="height: 56px; width: 134px" class="overlay-wrapper" colspan="2">
    <app-overlay [textStyle]="'font-size: 15px;'" [text]="rowStatus" />
  </td>
}
<td class="odd-cell">
  @if (isAutoBm) {
    <a class="value-cell dummy-cell" [ngClass]="{ changed: row?.lay2?.changed && priceChangeFlash }">
      <span class="value-price">
        {{ row?.lay2?.price || "-" }}
      </span>
      <span class="value-size">
        {{ row?.lay2?.size ? (row?.lay2?.size * exRate | number: "1.0-0") : "-" }}
      </span>
    </a>
  }
</td>
<td class="odd-cell">
  @if (isAutoBm) {
    <a class="value-cell dummy-cell" [ngClass]="{ changed: row?.lay3?.changed && priceChangeFlash }">
      <span class="value-price">
        {{ row?.lay3?.price || "-" }}
      </span>
      <span class="value-size">
        {{ row?.lay3?.size ? (row?.lay3?.size * exRate | number: "1.0-0") : "-" }}
      </span>
    </a>
  }
</td>
